import angular from 'angular'
import statisticsOpenedInvCtrl from './statisticsOpenedInvCtrl'

import { statisticsOpenedInv, openedInvoice } from 'redevConfig'
const list = (statisticsOpenedInv && statisticsOpenedInv.list) || ''
const detail = (statisticsOpenedInv && statisticsOpenedInv.detail) || ''
const relatedBill = (openedInvoice && openedInvoice.relatedBill) || ''
const statisticsOpenedInvList = list ? require(`redevelopment/statistics/statisticsOpenedInv/${list.templateName}`) : require('./view/statisticsOpenedInvList.html')
const statisticsOpenedInvListCtrl = list ? require(`redevelopment/statistics/statisticsOpenedInv/${list.controllerName}`) : require('./statisticsOpenedInvListCtrl')

const statisticsOpenedInvDetail = detail ? require(`redevelopment/statistics/statisticsOpenedInv/${detail.templateName}`) : require('./view/relatedBill_invoice.html')
const statisticsOpenedInvDetailCtrl = detail ? require(`redevelopment/statistics/statisticsOpenedInv/${detail.controllerName}`) : require('./statisticsOpenedInvDetailCtrl')
const relatedBillPage = relatedBill ? require(`redevelopment/outputManage/openedInvoice/${relatedBill.templateName}`) : require('app/outputManage/billManage/openedInvoice/view/relatedBill_invoice.html')
export default angular
    .module('app.statistics.outputStatistics.statisticsOpenedInv', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state('statistics.outputStatistics.statisticsOpenedInv', {
                abstract: true,
                url: '/statisticsOpenedInv',
                template: '<div ui-view></div>',
                controller: 'statisticsOpenedInvCtrl',
                title: '已开发票',
                default: 'statistics.outputStatistics.statisticsOpenedInv.list',
            })
            .state('statistics.outputStatistics.statisticsOpenedInv.list', {
                url: '/list',
                template: statisticsOpenedInvList,
                controller: 'statisticsOpenedInvListCtrl',
            })
            .state('statistics.outputStatistics.statisticsOpenedInv.detail', {
                url: '/detail/:waitId',
                template: statisticsOpenedInvDetail,
                controller: 'statisticsOpenedInvDetailCtrl',
                title: '发票详情',
            })
            .state('statistics.outputStatistics.statisticsOpenedInv.relatedBill', {
                url: '/relatedBill/:waitId',
                template: relatedBillPage,
                controller: 'openedRelatedBillCtrl',
                title: '关联销售单',
            })
    }])
    .controller('statisticsOpenedInvCtrl', statisticsOpenedInvCtrl)
    .controller('statisticsOpenedInvListCtrl', statisticsOpenedInvListCtrl.default)
    .controller('statisticsOpenedInvDetailCtrl', statisticsOpenedInvDetailCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/statisticsOpenedInv/index.js